import { Routes, Route } from 'react-router-dom';

//general
import PrivateRoute from './components/PrivateRoute';
import { useSelector } from 'react-redux';
import SettingsCollectionsWS from './screens/workshopPages/SettingsCollectionsWS';
import Dashboard from './screens/mainPages/Dashboard';

const ChekupRoutes = () => {

  const currentPlatform = useSelector(state => state.core.currentPlatform);
  return (
    <Routes>

      <Route
        path="/:collectionId"
        element={
          <PrivateRoute permission={['ADMIN', 'OWNER']}>
            <SettingsCollectionsWS />
          </PrivateRoute>
        }
      />

      <Route
        path="/dashboard"
        element={
          <PrivateRoute permission={['ADMIN', 'OWNER']}>
            <Dashboard />
          </PrivateRoute>
        }
      />


    </Routes>
  );
};

export default ChekupRoutes;
